<template>
  <div class="task-data" @click.stop>
    <TaskHeader
      :session="session"
      :task-name="taskName"
      :start-date="startDate"
      :duration="duration"
      :user-list="userList"
      :permissions="permissions"
      :show-icons="showIcons"
      @logs="emit('logs')"
      @stop="emit('stop')"
      @refresh="emit('refresh')"
      @delete="emit('delete')"
    />

    <hr class="task-data-separator">

    <TaskProgress
      class="task-progress-card"
      :status="sessionStatus || statusInfo?.status"
      :percent="statusInfo?.percent || 0"
      :message="statusInfo?.message || message"
      :stage-label="statusInfo?.stage_label"
      :stage-number="statusInfo?.stage_number"
      :total-stages="statusInfo?.total_stages"
      :task-u-i-d="taskUID"
      :user-name="userName"
      :parent-u-i-d="parentUID"
    />

    <hr class="task-data-separator">

    <TaskBatchStatus
      :process_info="processInfo"
    />
  </div>
</template>

<script setup>
import TaskHeader from '@/components/Apps/TaskHeader.vue';
import TaskProgress from '@/components/Apps/TaskProgress.vue';
import TaskBatchStatus from '@/components/Apps/TaskBatchStatus.vue';

defineProps({
  session: {
    type: Object,
    required: true,
  },
  taskName: {
    type: String,
    default: '',
  },
  startDate: {
    type: String,
    default: '',
  },
  duration: {
    type: String,
    default: '',
  },
  userList: {
    type: Array,
    default: () => [],
  },
  permissions: {
    type: Object,
    default: () => ({}),
  },
  showIcons: {
    type: Boolean,
    default: true,
  },
  sessionStatus: {
    type: String,
    default: '',
  },
  statusInfo: {
    type: Object,
    default: () => ({}),
  },
  message: {
    type: String,
    default: '',
  },
  taskUID: {
    type: String,
    default: '',
  },
  userName: {
    type: String,
    default: '',
  },
  parentUID: {
    type: String,
    default: '',
  },
  processInfo: {
    type: Object,
    default: () => ({
      id: '',
      status: '',
    }),
  },
});

const emit = defineEmits(['logs', 'stop', 'refresh', 'delete']);
</script>

<style scoped lang="scss">
.task-data {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 4px;
  box-sizing: border-box;
}

.task-progress-card {
  width: 100%;
}

.task-data-separator {
  width: 100%;
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 0;
}
</style>
